export default [
  {
    name: 'Outstanding',
    value: 0,
    class: 'danger',
    tooltip: 'Some costs not fully paid',
  },
  {
    name: 'Paid',
    value: 1,
    class: 'success',
    tooltip: 'All costs fully paid',
  },
  {
    name: 'To Pay on Account',
    value: 2,
    class: 'warning',
    tooltip: 'Will be paid for via an account payment',
  },
  {
    name: 'Paid on Account',
    value: 3,
    class: 'success',
    tooltip: 'Paid for via an account payment',
  },
  {
    name: 'Pre-Auth',
    value: 4,
    class: 'warning',
    tooltip: 'Paid for via Pre-Auth payment',
  },
];
